<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-3/12">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6">
              <ul class="d-block mb-4">
                <li><a href="https://alia.iugu.com/receive/invoices?invoices_page=0&ss_status=paid" target="_blank">Clique aqui para acessar a página de relatórios na Iugu</a></li>
                <li>Alterar a data para o período desejado</li>
                <li>Clicar em Exportar</li>
                <li>Escolha e aguarde o arquivo ser baixado</li>
              </ul>

              <label>
                <input type="file" id="file" ref="file" @change="handleFileUpload()" class="mb-4" accept=".csv"/>
              </label>

              <vs-button class="mr-3" icon-pack="feather" color="primary" icon="icon icon-x-circle" @click="submitFile"
              >Enviar Arquivo CSV
              </vs-button
              >
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-3/12">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4"
                style="background: rgba(var(--vs-success), 0.15)"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ missing.length }} ({{ missingTotal | money }})</h2>
                <span>Não Existe no Backend (Bruto)</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-3/12">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4"
                style="background: rgba(var(--vs-success), 0.15)"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ payments.length }} ({{ paymentsTotal | money }})</h2>
                <span>Existe no Backend e Arquivo (Bruto)</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-3/12">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4"
                style="background: rgba(var(--vs-success), 0.15)"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{ inexisting.length }} ({{ inexistingTotal | money }})</h2>
                <span>Não Existe no Arquivo (Bruto)</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="data-list-container mt-5" v-show="missing.length">
      <h1>Não Existe no Backend</h1>
      <vs-table ref="table" :data="missing" :sst="true" :stripe="true">
        <template slot="thead">
          <vs-th>DATA</vs-th>
          <vs-th>NOME/EMAIL</vs-th>
          <vs-th>VALOR</vs-th>
          <vs-th>ID IUGU</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" v-for="(tr, idx) in missing" :key="idx">
            <vs-td>{{ data[idx].DATA_DE_CRIACAO }}</vs-td>
            <vs-td>
              <div>{{ data[idx].NOME }}</div>
              <div>
                <router-link
                  :to="{ name: 'clientes', query: { email: data[idx].EMAIL } }"
                  target="_blank"
                >{{ data[idx].EMAIL }}
                </router-link>
              </div>
            </vs-td>
            <vs-td>R${{ data[idx].TOTAL }}</vs-td>
            <vs-td>
              <div>
                <a :href="'https://alia.iugu.com/receive/invoices/' + data[idx].CODIGO" target="_blank">{{
                    data[idx].CODIGO
                  }}</a>
              </div>
              <div v-show="!data[idx].CODIGO">
                <vs-button @click="newOrder(data[idx])">Criar Venda</vs-button>
              </div>
            </vs-td>
            <vs-td>
              <div>
                <a
                  :href="'https://www.paypal.com/billing/subscriptions/' + data[idx].CODIGO"
                  target="_blank"
                >{{ data[idx].CODIGO }}</a>
              </div>
              <div v-show="data[idx].CODIGO">
                <vs-button @click="newSubscription(data[idx])">Criar e Venda</vs-button>
                <div>
                  <small>A venda será criado com a data/hora da transação.</small>
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <div class="data-list-container mt-5" v-show="inexisting.length">
      <h1>Não Existe no Arquivo</h1>
      <vs-table ref="table" :data="inexisting" :sst="true" :stripe="true">
        <template slot="thead">
          <vs-th>DATA</vs-th>
          <vs-th>HORA</vs-th>
          <vs-th>NOME</vs-th>
          <vs-th>EMAIL</vs-th>
          <vs-th>BRUTO</vs-th>
          <vs-th>TAXA</vs-th>
          <vs-th>DESCONTO</vs-th>
          <vs-th>LIQUIDO</vs-th>
          <vs-th>NÚMERO</vs-th>
          <vs-th>ID IUGU</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" v-for="(tr, idx) in inexisting" :key="idx">
            <vs-td>{{ data[idx].created_at | formatDate }}</vs-td>
            <vs-td>{{ data[idx].created_at | formatTime }}</vs-td>
            <vs-td>{{ data[idx].user.name }}</vs-td>
            <vs-td
            >
              <router-link :to="{ name: 'cliente-detalhes', params: { id: data[idx].user.id } }">{{
                  data[idx].user.email
                }}
              </router-link>
            </vs-td
            >
            <vs-td>{{ data[idx].subtotal | money }}</vs-td>
            <vs-td>{{ data[idx].fee | money }}</vs-td>
            <vs-td>{{ data[idx].discount | money }}</vs-td>
            <vs-td>{{ data[idx].total | money }}</vs-td>
            <vs-td
            >
              <router-link :to="{ name: 'venda-detalhes', params: { id: data[idx].id } }" target="_blank">{{
                  data[idx].number
                }}
              </router-link>
            </vs-td
            >
            <vs-td v-if="data[idx].payments[0] && data[idx].payments[0].transaction_id.indexOf('-') === -1">
              <a
                :href="'https://alia.iugu.com/receive/invoices/' + data[idx].payments[0].transaction_id"
                target="_blank"
              >{{ data[idx].payments[0].transaction_id }}</a
              >
            </vs-td>
            <vs-td v-else>-</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      file: '',
      missing: [],
      missingTotal: 0,
      payments: [],
      paymentsTotal: 0,
      inexisting: [],
      inexistingTotal: 0,
      timeout: null
    }
  },

  mounted() {
  },

  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0]
    },
    newSubscription(transaction) {
      const q = confirm('Tem certeza que deseja criar uma nova assinatura e venda?')
      if (q) {
        this.$api
        .post('/api/v1/backend/reconciliation/paypal/newsubscription/true', transaction)
        .then(() => {
          this.$vs.notify({
            text: 'Assinatura e Venda criadas com sucesso',
            color: 'success'
          })

          this.missing = this.missing.filter(i => i.CODIGO !== transaction.CODIGO)
        })
        .catch((error) => {
          this.$vs.notify({
            title: 'Erro',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
      }
    },
    newOrder(transaction) {
      const q = confirm('Tem certeza que deseja criar uma nova venda?')
      if (q) {
        this.$api
        .post('/api/v1/backend/reconciliation/paypal/neworder', transaction)
        .then(() => {
          this.$vs.notify({
            text: 'Venda criada com sucesso',
            color: 'success'
          })

          this.missing = this.missing.filter(i => i.CODIGO !== transaction.CODIGO)
        })
        .catch((error) => {
          this.$vs.notify({
            title: 'Erro',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
      }
    },
    submitFile() {
      this.$vs.loading()
      let formData = new FormData()
      formData.append('file', this.file)

      this.$api
      .post('/api/v1/backend/reconciliation/iugu/csv', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => {
        this.$vs.loading.close()
        this.missing = response.data.missing
        this.missingTotal = response.data.missingTotal
        this.payments = response.data.payments
        this.paymentsTotal = response.data.paymentsTotal
        this.inexisting = response.data.inexisting
        this.inexistingTotal = response.data.inexistingTotal
      })
      .catch(() => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Erro',
          text: 'Falha ao processar o arquivo.',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      })
    }
  }
}
</script>

<style lang="scss">
.data-list-container {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          bg-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
